var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, nothing } from 'lit';
import { property } from 'lit/decorators.js';
// Components
import { BaseElement } from '@frontend_zz/base-element/BaseElement.js';
import { Button } from '@frontend_zz/button/Button.js';
import { Logo } from '@frontend_zz/logo/Logo.js';
import { Text } from '@frontend_zz/text/Text.js';
// Data
import content from './AppBar.content.json';
// Styling
import styles from './AppBar.css.js';
import { litFlex, litPillar } from '@frontend_zz/web-component-utilities/styles/utility/layout.css.js';
/**
 * @element zz-app-bar
 */
export class AppBar extends BaseElement {
    constructor() {
        super(...arguments);
        this.logoLink = '/';
        this.statusBarHeight = 0;
        this.renderTopOffset = (statusBarHeight) => {
            const { style } = this;
            const hasTopOffset = statusBarHeight > 0;
            if (!hasTopOffset) {
                return nothing;
            }
            style.setProperty('--top-offset-height', `${statusBarHeight}px`);
            return html `<div class="top-offset"></div>`;
        };
        this.renderCenterNavigation = () => {
            const { isMobile, title, logoLink } = this;
            if (title && isMobile) {
                return html `<zz-text ellipsis class="mobile-title" tag="h2" style-as="h6" responsive>${title}</zz-text>`;
            }
            return html `
            <zz-button href=${logoLink} aria-label=${content.homeLinkLabel} variant="icon-only">
                <zz-logo alt="logo" class="logo" variant=${isMobile ? 'without-text' : 'with-text'}></zz-logo>
            </zz-button>
        `;
        };
    }
    static get styles() {
        return [styles, litFlex, litPillar];
    }
    static get scopedElements() {
        return {
            'zz-button': Button,
            'zz-logo': Logo,
            'zz-text': Text,
        };
    }
    render() {
        const { statusBarHeight, renderCenterNavigation } = this;
        return html `
            <header>
                ${this.renderTopOffset(statusBarHeight)}
                <div class="inner-container">
                    <div class="inner">
                        <div class="left-section">
                            <nav class="left-navigation flex flex-align-center" aria-label="AppBar left navigation">
                                <slot name="left-navigation"></slot>
                            </nav>
                        </div>
                        <div slot="center-section">
                            <div class="flex flex-justify-center">${renderCenterNavigation()}</div>
                        </div>
                        <div class="right-section">
                            <nav class="right-navigation flex flex-align-center" aria-label="AppBar right navigation">
                                <slot name="right-navigation"></slot>
                            </nav>
                        </div>
                    </div>
                </div>
                <div class="bottom flex flex-row flex-align-center pillar-max">
                    <slot name="bottom-navigation"></slot>
                </div>
            </header>
        `;
    }
}
__decorate([
    property()
], AppBar.prototype, "title", void 0);
__decorate([
    property({ attribute: 'logo-link', reflect: false })
], AppBar.prototype, "logoLink", void 0);
__decorate([
    property({ type: Number, attribute: 'status-bar-height' })
], AppBar.prototype, "statusBarHeight", void 0);
